// extracted by mini-css-extract-plugin
export default {"marqueeWrapper":"pXQmjc","olsHealthAndVetsWrapper":"YImfs5"};